/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { buildingWireless1Duocolor } from "../assets/building-wireless-1-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconBuildingWireless1Duocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={buildingWireless1Duocolor.svg} />
);

IllustrativeIconBuildingWireless1Duocolor.displayName = "IllustrativeIconBuildingWireless1Duocolor";
